if (!customElements.get('required-checkbox-group')) {
  class RequiredCheckboxGroup extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.boxes = this.querySelectorAll('input[type="checkbox"]');

      this.boxes.forEach((b) => b.addEventListener('change', this.validate.bind(this)));
      this.validate();
    }

    validate() {
      const anyChecked = [...this.boxes].some((b) => b.checked);
      this.boxes[0].required = !anyChecked;
    }
  }
  customElements.define('required-checkbox-group', RequiredCheckboxGroup);
}
